var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.2402C22.02 13.9315 20.2508 12.7448 17.6925 12.6802L15.629 14.0116L13.5875 12.6952C13.1578 12.7063 11.2665 13.0362 11.2665 13.0362M10.7918 6.62808L11.0141 5.96281C11.4862 4.00875 12.5911 2 15.6778 2C18.7646 2 19.7889 4.01546 20.3416 5.96281C20.774 7.39816 21.0945 8.38152 21.3032 8.91289C21.4051 9.17238 21.2402 9.45294 20.9349 9.53955C20.9208 9.54356 19.6226 10.1349 17.7889 10.4451C17.1771 10.8355 16.4485 11.062 15.6666 11.062C14.9089 11.062 14.2014 10.8493 13.6016 10.4811C13.2202 10.4236 12.8468 10.3496 12.4815 10.259M15.6669 21C14.6113 17.8058 12.1543 16.2192 8.29594 16.2402C4.43755 16.2613 2.00557 17.8479 1 21M8.40652 6.27207C10.6341 6.27207 12.4399 8.02535 12.4399 10.1881C12.4399 12.3509 10.6341 14.1042 8.40652 14.1042C6.17894 14.1042 4.37313 12.3509 4.37313 10.1881C4.37313 8.02535 6.17894 6.27207 8.40652 6.27207Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9e69d587991778a0ce0d8b909e0e8ca6.svg";
export { ForwardRef as ReactComponent };